import React from 'react'
import { Modal } from 'react-bootstrap'

const RateConModal = ({ show, onHide, documentUrl }) => {
  return (
    <Modal show={show} onHide={onHide} size='lg' centered>
      <Modal.Header closeButton>
        <Modal.Title>Rate Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body className='d-flex justify-content-center'>
        {documentUrl ? (
          <iframe
            src={documentUrl}
            title='Rate Con Preview'
            width='100%'
            height='500px'
            style={{ border: 'none' }}
          />
        ) : (
          <p className='text-muted'>No document available</p>
        )}
      </Modal.Body>
    </Modal>
  )
}

export default RateConModal
